import React from "react"
import {CalendarEventForm} from "sections/calendar/parts/EventPopup"
import {useModel} from "hooks"
import {LinkedCalendarInfo, RSVP} from "types/calendar"
import {OPTIONS_FREQUENCY, OPTIONS_FREQUENCY_TYPE} from "sections/calendar/parts/common"
import {PanelExpandedSection} from "uiKit/PanelExpandedSection"
import {Auth} from "types/auth"
import moment from "moment"

type DisplayPart = "list" | "create"

type Props = {
    calendarId: any
    student?: Auth.DepartmentStudent
    selectedDate?: Date | null
    onNavigate?: (displayMode: DisplayPart) => void
    linkedCalendars: LinkedCalendarInfo[]
}

const getDefaultEventTimes = (date?: Date | null) => {
    const day = (date ? moment(date) : moment().add(1, "day")).startOf("day")
    return {
        startDate: day.clone(),
        startTime: day.clone().add(8, "hour"),
        endTime: day.clone().add(9, "hour")
    }
}

const INITIAL_PERSONAL_EVENT_DATA = {
    publicId: "",
    name: "",
    typeEvent: "",
    startDate: "",
    endDate: "",
    startTime: "",
    endTime: "",
    rsvp: RSVP.Yes,
    recurring: OPTIONS_FREQUENCY[0],
    end: OPTIONS_FREQUENCY_TYPE[0],
    executions: "",
    every: "",
    days: {},
    monthlyRecurring: 0,
    monthDay: {},
    monthWeek: {},
    monthWeekDay: {},
    notes: "",
    allDay: false,
    rrule: undefined,
    withInvitePushNotification: true,
    withPushNotification: true
}

export const CreateEvent = (props: Props) => {
    const {calendarId, student, selectedDate, onNavigate, linkedCalendars} = props
    const model = useModel()
    const defaultTimes = getDefaultEventTimes(selectedDate)

    return (
        <PanelExpandedSection title="Calendar - Create Event" onClose={() => onNavigate("list")}>
            <CalendarEventForm
                model={model}
                calendarId={calendarId}
                onClose={() => onNavigate("list")}
                initialEventData={{
                    ...INITIAL_PERSONAL_EVENT_DATA,
                    hostUsers: [model.user],
                    invitedUsers: student ? [student] : [],
                    startDate: defaultTimes.startDate,
                    startTime: defaultTimes.startTime,
                    endTime: defaultTimes.endTime
                }}
                onCreateSuccess={() => onNavigate?.("list")}
                displayMode="panel"
                linkedCalendars={linkedCalendars}
            />
        </PanelExpandedSection>
    )
}
